/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearRoutingModule
 * Purpose		: Routing module for SummaryofSalesbyYear.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SummaryofSalesbyYearListComponent } from './SummaryofSalesbyYearList.component';
import { SummaryofSalesbyYearDetailsComponent } from './SummaryofSalesbyYearDetails.component';

const SummaryofSalesbyYearRoutes: Routes = [
	{ path: 'SummaryofSalesbyYear',  component: SummaryofSalesbyYearListComponent },
	{ path: 'SummaryofSalesbyYear/Details/:id', component: SummaryofSalesbyYearDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(SummaryofSalesbyYearRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SummaryofSalesbyYearRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyYear/SummaryofSalesbyYear-routing.module.ts